import { useSelector } from 'react-redux';
import { getCampaignsForNewDealsToday, getTabs } from '@client/redux/modules/mylounge';
import { CategoryTabIds } from '@shared/constants';
import { Campaign } from '@shared/types/mylounge';

/**
 * Return type for useNewDealsData hook
 * Contains pure data fetching and filtering without business logic
 */
export interface UseNewDealsDataReturn {
    newDealsCampaigns: Campaign[];
}

/**
 * Hook for fetching and filtering new deals campaign data
 * Handles Redux selectors and campaign filtering (removes THB)
 * Pure data layer - no business logic, no variant checks
 *
 * @returns {UseNewDealsDataReturn} Filtered campaigns
 */
export const useNewDealsData = (): UseNewDealsDataReturn => {
    const tabs = useSelector(getTabs);
    const allNewDealsCampaigns = useSelector(getCampaignsForNewDealsToday) || [];

    // Filter out "All Campaigns" THB campaign
    const allCampaignsThbCampaignId = tabs?.find(tab => tab.id === CategoryTabIds.ALL)?.thb?.id;
    const newDealsCampaigns = allNewDealsCampaigns.filter(
        campaign => campaign.campaignId !== allCampaignsThbCampaignId,
    );

    return {
        newDealsCampaigns,
    };
};
